<div
  app-kirjanpito-tosite-naytto
  [isMainEnhancedOn]="isMainEnhancedOn"
  class="mat-elevation-z8 app-kirjanpito-tosite-esikatselu"
  style="border-radius: 20px"
  [naytaRuksi]="true"
  [scrollContainerRef]="mainDivRef"
  (ruksiaNapautettiin)="ruksiaNapautettiinHandler($event)"
  [naytettavatTositteetJaSivut]="tositteet"
  [naytettavaKirjausObservable]="naytettavaKirjausObservable"
  (liitaTositeValittuunKirjaukseen)="liitaTositeValittuunKirjaukseenHandler($event)"
></div>
